import {
  rpaUserWorkflowsResponseSchema,
  type RpaUserWorkflowsResponse,
} from '@/features/rpa/recorder/lib/user-workflows-schema';
import type {
  SkillSummary,
  UserWorkflowsResult,
} from '@/features/rpa/recorder/types/skill-summary';

function titleFromWire(workflowName: string | null | undefined, name: string): string {
  const trimmedWorkflow = workflowName?.trim();
  const trimmedName = name.trim();
  return trimmedWorkflow || trimmedName || 'Untitled skill';
}

function mapPersonalRecordingSummary(
  wire: RpaUserWorkflowsResponse['personal_recordings'][number]
): SkillSummary {
  return {
    recordingId: wire.recording_id,
    ...(wire.skill_id ? { skillId: wire.skill_id } : {}),
    // The desktop uploads with `Idempotency-Key: <sessionId>`.
    ...(wire.idempotency_key ? { sessionId: wire.idempotency_key } : {}),
    title: titleFromWire(wire.workflow_name, wire.name),
    status: wire.status,
    createdAt: wire.created_at,
    completedAt: wire.completed_at ?? null,
    errorCode: wire.error_code ?? null,
  };
}

function mapTeamWorkflowSummary(
  wire: RpaUserWorkflowsResponse['team_workflows'][number]
): SkillSummary {
  return {
    recordingId: wire.recording_id,
    ...(wire.skill_id ? { skillId: wire.skill_id } : {}),
    title: titleFromWire(wire.workflow_name, wire.name),
    status: 'ready',
    createdAt: wire.created_at,
    completedAt: wire.updated_at ?? wire.promoted_at ?? null,
    errorCode: null,
  };
}

export function mapUserWorkflows(json: unknown): UserWorkflowsResult {
  const parsed = rpaUserWorkflowsResponseSchema.parse(json);
  return {
    personal: parsed.personal_recordings.map(mapPersonalRecordingSummary),
    team: parsed.team_workflows.map(mapTeamWorkflowSummary),
  };
}
